import { render, staticRenderFns } from "./vue-flow-editor-preview.vue?vue&type=template&id=5b315a60"
import script from "./vue-flow-editor-preview.vue?vue&type=script&lang=js"
export * from "./vue-flow-editor-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b315a60')) {
      api.createRecord('5b315a60', component.options)
    } else {
      api.reload('5b315a60', component.options)
    }
    module.hot.accept("./vue-flow-editor-preview.vue?vue&type=template&id=5b315a60", function () {
      api.rerender('5b315a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/g6-canvas/editor/vue-flow-editor-preview.vue"
export default component.exports